import React, { useContext } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import LayoutContext, { ACTIONS, LAYOUTS } from '../../contexts/Layout';

export const Snack = ({ leftFrameWidth, rightFrameWidth }) => {
    const { layout, dispatch } = useContext(LayoutContext);

    if (layout.mode === LAYOUTS.Classic) {
        return (
            <View style={Styles.container}>
                <View style={Styles.wrapper}>
                    <Text style={Styles.text}>Window Dimensions {`${layout.dimensions.width}px X ${layout.dimensions.height}px`}</Text>
                    <Pressable
                        onPress={() => {
                            dispatch({
                                type: ACTIONS.SWITCH_LAYOUT
                            });
                        }}
                    >
                        <Text style={Styles.text}>Switch Layout</Text>
                    </Pressable>
                </View>
            </View>
        );
    } else if (layout.mode === LAYOUTS.Modern) {
        return (
            <View style={Styles.container}>
                <View style={Styles.wrapper}>
                    <Text style={Styles.text}>Window Dimensions {`${layout.dimensions.width}px X ${layout.dimensions.height}px`}</Text>
                    <Text style={Styles.text}>Left Frame Dimensions {`${leftFrameWidth}px X ${layout.dimensions.height}px`}</Text>
                    <Text style={Styles.text}>Right Frame Dimensions {`${rightFrameWidth}px X ${layout.dimensions.height}px`}</Text>
                    <Pressable
                        onPress={() => {
                            dispatch({
                                type: ACTIONS.SWITCH_LAYOUT
                            });
                        }}
                    >
                        <Text style={Styles.text}>Switch Layout</Text>
                    </Pressable>
                </View>
            </View>
        );
    }
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        bottom: 10,
        flexDirection: 'row',
        justifyContent: 'center',
        position: 'absolute',
        left: 10
    },
    text: {
        color: 'white',
        fontFamily: 'Helvetica',
        fontSize: '10pt',
        marginTop: 5
    },
    wrapper: {
        backgroundColor: 'black',
        height: '15%',
        padding: 5,
        textAlign: 'center'
    }
});
